<template>
  <div>
    <!-- <div>
      <van-nav-bar title="资讯详情" />
    </div> -->
    <!-- 内容 -->
    <div class="essay">
      <div class="essayTitle">{{ list.Title }}</div>
      <div class="rikind">{{ list.TKName }}</div>
      <!-- <div v-if="list.AImgUrl"
        class="essayImg">
        <img :src="list.AImgUrl"
          alt="" />
      </div> -->
      <div class="essayContent" v-html="list.Content" @click="imageEnlargement"></div>
      <div class="video" v-if="list.Annex">
        <video style="width: 100%" :src="list.Annex" controls="controls">
          您的浏览器不支持 video 标签。
        </video>
      </div>
      <div class="rikind" style="text-align: right;">{{ list.IssTime }}</div>
    </div>
    <van-button
      v-if="paId == 2"
      style="background-color: #617bfa;border-radius: 5px;"
      class="button"
      @click="Activity(list.AId)"
      round
      type="info"
      >心得体会</van-button
    >
  </div>
</template>
<script>
import { ImagePreview } from 'vant'
import { WeGetPBActivityDetail, WePBEnrolActivity } from '@/api/RealInfo'
import { setOpenId, getOpenId } from '@/utils/auth'
import { Dialog } from 'vant'
import Pdfh5 from 'pdfh5'
export default {
  components: {
    [Dialog.Component.name]: Dialog.Component,
  },
  data() {
    return {
      list: {}, //活动详情
      aids: 0, //活动aid
      ActivityFrom: {}, //活动申请提交参数
      pdf: '',
      paId: '',
    }
  },
  created() {
    // 获取并保存openid
    if (this.$route.query['openid']) {
      setOpenId(this.$route.query['openid'])
    }
  },
  methods: {
    // 获取活动详情
    getRealInfo() {
      this.aids = this.$route.params.Id
      this.paId = this.$route.params.paId
      WeGetPBActivityDetail(this.aids).then((res) => {
        this.list = res.data.data
        // this.pdf = 'https://api.qxzhqm.cn//upload/files/2022/3/ThingJS-X应用模板制作标准.pdf'
        // console.log(this.pdf);
        // this.list.Content = this.list.Content.replace(/<.*?>/ig,"")
        // console.log(this.list.Content);
      })
    },
    // 上传心得体会
    Activity(row) {
      var path = '/detail/recActLogs/' + row
      this.$router.push(path)
      // this.ActivityFrom.AId = this.aids;
      // this.ActivityFrom.OpenID = getOpenId();
      // WePBEnrolActivity(this.ActivityFrom).then((res) => {
      //   console.log(res);
      //   if (res.data.code == 0) {
      //     Dialog.alert({
      //       message: "提交成功!",
      //     }).then(() => {
      //       this.$router.go(-1)
      //     });

      //   } else {
      //     Dialog.alert({
      //       message: "申请失败," + res.data.msg,
      //     }).then(() => {
      //     });
      //   }
      // });
    },
    // 富文本图片内容 点击放大
    imageEnlargement(e) {
      if (e.target.nodeName === 'IMG') {
        ImagePreview({
          images: [e.target.src], // 传递的是图片集数组
          startPosition: 0, // 图片索引位置
          closeable: true, // 是否显示关了按钮
          showIndicators: true, // 是否显示轮播指示器
          loop: false, // 不设置为false,首图和尾部图不能正常加载
        })
      }
    },
  },
  mounted() {
    this.getRealInfo()
  },
}
</script>
<style>
.essay {
  padding-bottom: 80px;
}
.button {
  width: 95%;
  margin: 15px 2.5%;
  position: fixed;
  bottom: 0;
}
.essay .essayContent img {
  display: block;
  width: 100%;
}
</style>
